<template>
  <div class="page-container-item">
    <div class="menu-info">
      <div class="date">
        <h2>
          {{ formatDate(item.name) }}
        </h2>
      </div>
      <div
        v-if="item.breakfast"
        class="breakfast"
      >
        <h3>{{ $t('pages.dining.breakfast') }}</h3>
        <pre>{{ item.breakfast }}</pre>
      </div>
      <div
        v-if="item.lunch"
        class="lunch"
      >
        <h3>{{ $t('pages.dining.lunch') }}</h3>
        <pre>{{ item.lunch }}</pre>
      </div>
      <div
        v-if="item.dinner"
        class="dinner"
      >
        <h3>{{ $t('pages.dining.dinner') }}</h3>
        <p>{{ item.dinner }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from '../../../helpers/section/dining.async';

export default {
  name: 'MenuItem',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  methods: { formatDate }
};
</script>

<style lang="scss" scoped>
.date h2 {
  color: var(--primary-color);
  font-weight: 400;
  font-size: 16px;
  text-transform: uppercase;
}
.breakfast h3,
.lunch h3,
.dinner h3 {
  color: var(--heading-color);
  font-size: 17px;
  font-weight: 700;
  text-decoration: underline;
  margin: 12px 0;
}
.breakfast pre,
.lunch pre {
  font-size: 15px;
  font-family: inherit;
  white-space: break-spaces;
}
</style>
